
import { ISiteConfigDataInitialState } from "../../types/spinnerDatainterface";

import loadingSkeletonImg from "../../images/logo_loading_skeleton.gif"
import { SiteConfigDataActionTypes, SiteConfigDataActions } from "../actions/siteConfigDataActions";

const initialState : ISiteConfigDataInitialState = {
 logo_img: loadingSkeletonImg,
 colors: {
    primary_default: "",
    primary_dark: "",
    primary_medium: "",
    primary_light: "",
 }
}

export default function siteConfigReducer(state = initialState, action: SiteConfigDataActionTypes) : ISiteConfigDataInitialState {
    switch (action.type) {
        case SiteConfigDataActions.SET_THEME_CONFIG_DATA:
            return action.payload;
        default:
            return state;
    }
}